import { useEffect, useRef, useState } from "react";
import { Play, Pause, Loader2 } from "lucide-react";
import { musicApi, fmtTime } from "@/lib/musicApi";
import { Waveform } from "@/components/music/Waveform";

// Private audio: fetched with the session (blob), so files are never publicly reachable.
export const AudioPlayer = ({ src, peaks, duration, testId = "audio-player", color }) => {
  const audio = useRef(null);
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [t, setT] = useState(0);

  useEffect(() => () => { if (url) URL.revokeObjectURL(url); }, [url]);

  const ensure = async () => {
    if (url) return url;
    setLoading(true);
    try { const b = await musicApi.blob(src); const u = URL.createObjectURL(b); setUrl(u); return u; }
    finally { setLoading(false); }
  };
  const toggle = async () => {
    const a = audio.current;
    if (!url) { a.src = await ensure(); }
    if (a.paused) { await a.play(); } else a.pause();
  };
  const seek = async (f) => {
    const a = audio.current;
    if (!url) { a.src = await ensure(); await a.play(); }
    a.currentTime = f * (a.duration || duration || 0);
  };
  const total = audio.current?.duration || duration || 0;

  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <audio ref={audio} onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)}
        onTimeUpdate={(e) => setT(e.currentTarget.currentTime)} preload="none" />
      <button onClick={toggle} data-testid={`${testId}-play`} aria-label={playing ? "Pause" : "Play"}
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#C8FF4D] text-black transition-transform hover:scale-105 active:scale-95">
        {loading ? <Loader2 size={16} className="animate-spin" /> : playing ? <Pause size={16} /> : <Play size={16} className="ml-0.5" />}
      </button>
      <div className="min-w-0 flex-1"><Waveform peaks={peaks} progress={total ? t / total : 0} onSeek={seek} height={44} color={color} testId={`${testId}-wave`} /></div>
      <span className="w-[74px] shrink-0 text-right font-mono text-[11px] text-white/50">{fmtTime(t)} / {fmtTime(total)}</span>
    </div>
  );
};
